<template>
  <div>
    <v-row v-if="isSaving">
      <v-col cols="12" class="text-center">
        Signing...
        <v-progress-linear :indeterminate="true">
        </v-progress-linear>
      </v-col>
    </v-row>
    <v-row v-else-if="value">
      <v-col cols="12" class="text-center">
        <v-icon color="success">{{ mdiCheck }}</v-icon>
        <span class="font-weight-bold">Signed</span>
      </v-col>
      <v-progress-circular :indeterminate="true" v-if="isLoading"></v-progress-circular>
      <v-col v-if="signedObj" cols="12" class="text-center">
        <span class="font-weight-bold">{{ signedObj.username }}</span>
        signed on {{ formatDate(signedObj.created) }} logged in as {{ signedObj.createdBy }}
      </v-col>
    </v-row>
    <v-row v-else class="text-left">
      <v-col :cols="cols">
        <span class="text-h5">{{ title }}</span>
        <v-select
          :items="usernames"
          v-model="username"
          item-text="username"
          item-value="username"
          :disabled="false"
        ></v-select>
      </v-col>
      <v-col :cols="cols">
        <span class="text-h5 mb-10">Signature:</span><br />
        <pin-dialog label="Sign" @sign="sign" />
        <v-alert class="mt-5" type="error" v-if="error">
          {{ error }}
        </v-alert>
      </v-col>
      <v-col :cols="cols">
        <span class="text-h5">Date:</span><br />
        <span class="text-h6">{{ formatDate(new Date()) }}</span>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { mdiCheck } from '@mdi/js';
import loading from '@codehq/aurora-app-core/src/mixins/loading';
import PinDialog from './PinDialog.vue';

export default {
  components: { PinDialog },
  name: 'SignVerification',
  mixins: [loading],
  props: {
    role: {
      type: String,
      default: 'Operator',
    },
    title: {
      type: String,
      default: 'Requested By',
    },
    reportName: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: undefined,
    },
  },
  data() {
    return {
      mdiCheck,
      error: undefined,
      username: 'undefined',
      usernames: [],
      signedObj: undefined,
    };
  },
  watch: {
    value() {
      if (this.value) {
        this.loadSigned(this.value);
      }
    },
  },
  computed: {
    cols() {
      if (this.hideDate) {
        return 6;
      }
      return 4;
    },
  },
  async mounted() {
    this.usernames = await this.LOAD_usernames();
    if (this.value) {
      this.loadSigned(this.value);
    }
  },
  methods: {
    ...mapActions('userPins', ['LOAD_usernames']),
    async loadSigned(id) {
      this.isLoading = true;
      const { data } = await this.$http.get(`/api/sign/${id}`);
      this.signedObj = data;
      this.isLoading = false;
    },
    async sign(code) {
      const { username, reportName, role } = this;
      try {
        this.isSaving = true;
        this.error = undefined;
        const { data } = await this.$http.post('/api/sign', {
          username,
          reportName,
          role,
          code,
        });
        console.debug(data);
        this.$emit('signed', data);
        this.$emit('input', data.id);
      } catch (error) {
        this.$emit('error', error);
        this.error = 'Signature failed';
      } finally {
        this.isSaving = false;
      }
    },
  },
};
</script>
